let prevClick = 'ying';
let ying_videoTl, paw_videoTl, tl;

addEventListener('DOMContentLoaded', (event) => {
  ying_videoTl = gsap.timeline({ defaults: { duration: 2, ease: 'expo.inOut', pause: true } });
  ying_videoTl.set('#ying-video-container', { transformOrigin: '100% 50%', width: '0' });
  ying_videoTl.fromTo('#ying-video-container', { width: '0%' }, { width: '100%', opacity: 1 }, 0);

  paw_videoTl = gsap.timeline({ defaults: { duration: 2, ease: 'expo.inOut', pause: true } });
  paw_videoTl.set('#paw-video-container', { transformOrigin: '100% 50%', width: '0' });
  paw_videoTl.fromTo('#paw-video-container', { width: '0%' }, { width: '100%', opacity: 1 }, 0.15);
  tl.to(['.ying-brand-button', '.paw-brand-button'], { display: 'none' });
});

function toggleBrandMobile(prevClick) {
  tl = gsap.timeline({ defaults: { duration: 1.5, ease: 'power2.inOut' } });
  if (prevClick === 'ying') {
    tl.to('.ying-wrapper', { height: '80%', blur: 10 }, 0);
    tl.to('.paw-wrapper', { height: '20%', blur: 0 }, 0);
  } else {
    tl.to('.ying-wrapper', { height: '20%', blur: 0 }, 0);
    tl.to('.paw-wrapper', { height: '80%', blur: 10 }, 0);
  }
}

function toggleBrandDesktop(prevClick) {
  tl = gsap.timeline({ defaults: { duration: 1.5, ease: 'power2.inOut' } });
  if (prevClick === 'ying') {
    tl.to('.ying-wrapper', { width: '80%', blur: 10 }, 0);
    tl.to('.paw-wrapper', { width: '20%', blur: 0 }, 0);
  } else {
    tl.to('.ying-wrapper', { width: '20%', blur: 0 }, 0);
    tl.to('.paw-wrapper', { width: '80%', blur: 10 }, 0);
  }
}

function toggleVideo(prevClick) {
  if (prevClick === 'ying') {
    ying_videoTl.play();
    paw_videoTl.reverse();
  } else {
    ying_videoTl.reverse();
    paw_videoTl.play();
  }
}

const genClickListener = (isMobile) => {
  document.addEventListener('click', function (event) {
    event.stopPropagation();
    // check click state
    if (event.target.matches('.ying-button')) prevClick = 'ying';
    else if (event.target.matches('.paw-button')) prevClick = 'paw';

    if (isMobile) {
      toggleBrandMobile(prevClick);
    } else {
      toggleBrandDesktop(prevClick);
    }
    toggleVideo(prevClick);

    if (event.target.matches('.ying-button')) {
      tl.to('.ying-description', { visibility: 'visible', opacity: 1 }, 0.2);
      tl.to('.ying-brand-button', { display: 'block' }, 0.2);
    } else {
      tl.to('.ying-description', { visibility: 'hidden', opacity: 0 }, 0.2);
      tl.to('.ying-brand-button', { display: 'none' }, 0.2);
    }

    if (event.target.matches('.paw-button')) {
      tl.to('.paw-description', { visibility: 'visible', opacity: 1 }, 0.2);
      tl.to('.paw-brand-button', { display: 'block' }, 0.2);
    } else {
      tl.to('.paw-description', { visibility: 'hidden', opacity: 0 }, 0.2);
      tl.to('.paw-brand-button', { display: 'none' }, 0.2);
    }
  });
};

// Define the media query
const mediaQuery = window.matchMedia('(max-width: 749px)');

// Function to handle changes in the media query
const handleMediaQueryChange = (mediaQuery) => {
  if (mediaQuery.matches) {
    isMobile = true;
    genClickListener(isMobile);
  } else {
    isMobile = false;
    genClickListener(isMobile);
  }
};

// Initial check of the media query
handleMediaQueryChange(mediaQuery);

// Add an event listener to listen for changes in the media query
mediaQuery.addEventListener('change', handleMediaQueryChange);
